import React from 'react'
import ReactDOM from 'react-dom';
import Checkbox from 'components/marketplace/checkbox';

class FilterCheckboxOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 'active',
      collapse: 'in'
    }
    this.handleClick = this.handleClick.bind(this);
    this.renderOptionNotFound = this.renderOptionNotFound.bind(this);
  }

  handleClick(event) {
    const classList = event.target.className;
    if (classList.indexOf("active") >= 0) {
      this.setState({ 
        active: '',
        collapse: '',
      });
    } else {
      this.setState({ 
        active: 'active',
        collapse: 'in',
      });
    }
  }

  renderOptionNotFound() {
    const { option, handleCheckbox, name, selectedValues } = this.props;
    return (
      <form>
        <h5 className={`cars-search-option make-option ${this.state.active}`} data-toggle="collapse" data-target={`.${name}`} onClick={this.handleClick}>{name}</h5>
        <div className={`cars-collapse ${name} collapse ${this.state.collapse}`}>
          <p>Option not found</p>
        </div>
      </form>
    );
  }

  render() {
    const { option, handleCheckbox, name, selectedValues } = this.props;
    let types = this.props.type

    if (Array.isArray(types) && types.indexOf(null) >= 0) { types = types.filter(type => type) }

    let renderCheckbox = null;

    if (types != null && types[0] != null) {
      renderCheckbox = types.map((type, index) => {
        if (typeof type === "object") {
          return <Checkbox option={option} key={index} checkboxOption={type.name} handleChange={handleCheckbox} checked={selectedValues.indexOf(type.name) >= 0}/>
        } else if (typeof type === "string") {
          return <Checkbox option={option} key={index} checkboxOption={type} handleChange={handleCheckbox} checked={selectedValues.indexOf(type) >= 0}/>
        } else {
          return (
            this.renderOptionNotFound()
          );
        }
       })
    } else {
      return (
        this.renderOptionNotFound()
      );
    }

    if (name === 'Tender' || types.length > 1) {
      return (
        <form>
          <h5 className={`cars-search-option make-option ${this.state.active}`} data-toggle="collapse" data-target={`.${name}`} onClick={this.handleClick}>{name}</h5>
          <div className={`cars-collapse ${name} collapse ${this.state.collapse}`}>
            {renderCheckbox}
          </div>
        </form>
      )
    } else {
      return null;
    }
  }
};

export default FilterCheckboxOption;
